module.exports = __webpack_public_path__ + "8bd345754ed0c32c49b336a2814c0a12.png";